var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQExpired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "641.000000pt",
    height: "589.000000pt",
    viewBox: "0 0 641.000000 589.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,589.000000) scale(0.100000,-0.100000)",
    fill: "#6eb0b1",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2805 5739 c-640 -30 -1278 -349 -1697 -848 -169 -202 -335 -489 -420 -727 -146 -405 -181 -867 -97 -1285 163 -817 738 -1491 1523 -1784 125 -46 285 -88 446 -117 108 -20 159 -23 380 -22 180 0 282 5 347 15 l91 15 44 -54 c108 -136 308 -292 471 -367 314 -145 678 -170 998 -69 201 63 382 171 537 318 123 118 209 234 281 381 106 214 145 381 144 615 0 214 -40 396 -128 587 -75 163 -231 363 -367 471 l-54 44 15 91 c23 139 21 547 -2 697 -82 514 -314 976 -677 1340 -424 426 -1012 682 -1615 702 -44 2 -143 0 -220 -3z m335 -1734 l0 -865 -630 0 -630 0 0 165 0 165 460 0 460 0 0 700 0 700 170 0 170 0 0 -865z m1543 -1176 c256 -52 492 -204 641 -411 65 -92 132 -237 163 -353 23 -88 26 -119 26 -255 0 -135 -3 -168 -26 -252 -82 -307 -288 -556 -571 -689 -281 -132 -609 -128 -891 10 -116 57 -183 105 -279 199 -351 345 -406 894 -130 1308 163 245 438 417 729 457 89 12 243 6 338 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4310 2005 l0 -525 170 0 170 0 0 525 0 525 -170 0 -170 0 0 -525z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4310 1165 l0 -135 168 2 167 3 3 133 3 132 -171 0 -170 0 0 -135z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQExpired);
export default __webpack_public_path__ + "static/media/qExpired.f8e88b486747f1e2cb099daf177d71cc.svg";
export { ForwardRef as ReactComponent };